import React from 'react';
import PropTypes from 'prop-types';

const Quote = ({ price }) => {
  const formattedPrice = price || '--';
  return (
    <div className='row equal quoteBox'>
      <div className='col-xs-12 col-sm-6 title'>
        <p>Your Report Quote</p>
      </div>
      <div className='col-xs-12 col-sm-6 price'>
        <p>{formattedPrice}</p>
      </div>
    </div>
  );
};

Quote.propTypes = {
  price: PropTypes.string,
};

export default Quote;



// WEBPACK FOOTER //
// ./modules/DataExports/components/PurchaseData/children/Quote/Quote.js